<div class="scale">
  <label>{{ lefttext }}</label>
  <div class="core">
    @for (s of [].constructor(steps); track $index; let i = $index) {
      <div class="number">
        <nb-radio [disabled]="disabled" [status]="status" [value]="i+1" [name]="name" (valueChange)="value = $event; onChange(value)" [checked]="value === i+1" ></nb-radio>
        <span (click)="this.value = i+1">{{ i+1 }}</span>
      </div>
    }
  </div>
  <label>{{ righttext }}</label>
</div>
